import { getContentDispositionFileName } from '../../utils/contentDisposition';
import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../../utils/errors';
import { triggerDownloadWithAnchorTag } from '../../utils/triggerDownloadWithAnchorTag';
import { portalGatewayClient } from '../portalGatewayClient';

export const downloadTableRow = async ({
  contentId,
  actionId,
  actionRowIds,
  defaultFileName,
}: {
  contentId: string;
  actionId: string;
  actionRowIds: string[];
  defaultFileName: string;
}) => {
  const response = await portalGatewayClient.table.downloadTableRows(
    contentId,
    {
      actionId,
      actionRowIds,
    }
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(
        await response.json(),
        'Error downloading table row data'
      ),
      response.status
    );
  }

  const contentDisposition = response.headers.get('content-disposition');

  const fileName =
    (contentDisposition && getContentDispositionFileName(contentDisposition)) ??
    defaultFileName;

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  triggerDownloadWithAnchorTag(blobUrl, fileName);
};
